import { createFileRoute } from '@tanstack/react-router';
import { Package } from 'lucide-react';
import { ComingSoonPage } from '@/components/sysadmin/coming-soon';

export const Route = createFileRoute('/sysadmin/platform/updates')({
  component: () => (
    <ComingSoonPage
      icon={Package}
      title="Updates"
      specRef="§3.8"
      wave="Phase 6"
      description="Air-gap update packages, signed bundles. Delta packages are 2-5 GB instead of the full 50+ GB install. USB-import workflow with Ed25519 signature verification before any byte hits disk; failed signatures auto-rollback and quarantine the upload."
      bullets={[
        'Installed platform version + last update timestamp',
        'Available delta packages — Ed25519 signed, USB-importable',
        'Apply / verify / rollback — every action audit-logged',
        'Rollback time-window per release (default 24h post-apply)',
        'Pre-apply dry-run: shows DB migrations + breaking changes',
        'Air-gap channel: never reaches the public update server',
      ]}
    />
  ),
});
